<template>
  <el-dialog :visible.sync="show" :title="title" width="100%" @open="openDialog" @close="handleClose"
    :close-on-click-modal="false" custom-class="my-dialog">
    <div class="content_box" v-if="article.length > 0">
      <div class="top" :class="{ padding_box: tabType != 2 }">
        <div class="article_logo" v-if="tabType != 2">
          <div class="top_img">
            <img :src="article[detailIndex].imageUrl" />
          </div>
          <div class="change_box">
            <span v-for="(item, index) in article" :key="index"
              :class="{ right_box: index != article.length - 1, active: index == detailIndex }"
              @mouseenter="handleMouseEnter(index)"></span>
          </div>
        </div>
        <div class="img_list" v-else>
          <div v-for="(item, index) in article" :key="index">
            <img :src="item.imageUrl" alt="">
          </div>
        </div>
        <div class="article_set">
          <div>
            <div>
              <img src="../../assets/images/close_icon.png" alt="" @click="handleClose">
              关闭
            </div>
            <div>
              <img src="../../assets/images/link_icon3.png" alt="" @click="handleOpen">
              原文链接
            </div>
            <div>
              <img src="../../assets/images/share_icon.png" alt="" @click="handleCopy">
              转发分享
            </div>
          </div>
        </div>
      </div>
      <div class="bottom" v-if="tabType != 2">
        <div class="content_bot">
          <div class="title">
            {{ article[detailIndex].title }}
          </div>
          <div class="content_val">
            {{ article[detailIndex].content }}
          </div>
        </div>
        <i class="el-icon-arrow-left leftIcon" @click="handlesubtract"></i>
        <i class="el-icon-arrow-right rightIcon" @click="handleadd"></i>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getArticleDetail } from '@/api/apis'
export default {
  props: {
    tabType: {
      type: Number | String,
      default: 1
    }
  },
  data() {
    return {
      show: false,
      title: '',
      article: [],
      detailId: '',
      detailIndex: 0,
      timer: null
    }
  },
  beforeDestroy() {
    this.handleclearInterval()
  },
  methods: {
    // 弹窗打开
    openDialog() {
      getArticleDetail({ id: this.detailId, isToken: true }).then(res => {
        this.article = res.data.detailList && res.data.detailList.length ? res.data.detailList : []
        if (this.article.length > 1) {
          this.handleTimeOut()
        }
      }).catch(err => {

      })
    },
    // 关闭
    handleClose() {
      this.show = false
      this.article = []
      this.detailIndex = 0
      this.handleclearInterval()
    },
    // 复制
    handleCopy() {
      const textarea = document.createElement("textarea");
      textarea.value = this.article.length > 0 ? this.article[this.detailIndex].url : '';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success('复制成功！')
    },
    // 打开链接
    handleOpen() {
      if (this.article[this.detailIndex].url) {
        window.open(this.article[this.detailIndex].url, '_blank')
      }

    },
    handlesubtract() {
      if (this.detailIndex == 0) return
      this.detailIndex -= 1
    },
    handleadd() {
      if (this.detailIndex == this.article.length - 1) return
      this.detailIndex++
    },
    handleMouseEnter(index) {
      this.detailIndex = index
    },
    handleTimeOut() {
      this.timer = setInterval(item => {
        this.detailIndex = (this.detailIndex + 1) % this.article.length;

      }, 3000)
    },
    handleclearInterval() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
  }
}
</script>

<style>
.v-modal {
  opacity: 0.8 !important;
  /* 0 完全透明，1 全黑 */
}
</style>
<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    height: 100vh;
    margin: 0 auto !important;
    background: transparent;
    box-shadow: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__header {
    display: none;
  }

  .v-modal {
    opacity: .8;
  }
}

.content_box {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;

  .top {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
    padding: 20px 0;

    .article_logo {
      margin-right: 80px;
      display: flex;
      flex-direction: column;

      .top_img {
        overflow: hidden;

        img {
          height: 620px;
          transition: all 0.3s linear;
        }
      }

      .change_box {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;

        span {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #fff;
          cursor: pointer;

        }

        .right_box {
          margin-right: 10px;
        }

        .active {
          background: transparent;
          border: 1px solid red;
          transition: all 0.3s linear;
        }
      }

    }

    .img_list {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 80px;

      div {
        text-align: center;
      }

      img {
        margin-bottom: 20px;
      }
    }

    .article_set {
      display: flex;
      flex-direction: column;

      >div {
        position: fixed;
        top: 80px;

        div {
          color: #FFFFFF;
          font-size: 18px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 20px;

          img {
            width: 40px;
            height: 40px;
            margin-bottom: 10px;
            cursor: pointer;
          }

          &:nth-child(2) {
            margin-top: 160px;
          }

          &:nth-child(3) {
            margin-top: 30px;
          }
        }
      }

    }
  }

  .padding_box {
    padding: 60px 0 20px !important;
  }

  .bottom {
    width: 100%;
    height: 270px;
    background: #000000;
    position: relative;

    .content_bot {
      width: 55%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      color: #fff;

      .title {
        text-align: center;
        width: 100%;
        text-align: center;
        font-size: 22px;
        font-weight: 600;
        padding: 20px 0;
      }

      .content_val {
        width: 100%;
        flex: 1;
        font-size: 18px;
        overflow-y: auto;
      }

    }

    .leftIcon {
      position: absolute;
      left: 15%;
      top: 50%;
      transform: translateY(-50%);
      font-size: 70px;
      color: #666565;
      cursor: pointer;
    }

    .rightIcon {
      position: absolute;
      right: 15%;
      top: 50%;
      transform: translateY(-50%);
      font-size: 70px;
      color: #666565;
      cursor: pointer;
    }

  }
}
</style>